module.exports = __webpack_public_path__ + "static/media/injection.348990a3.png";